export class EventsConstants {
	// Auth
	public static readonly AUTH_CONNECTED = 'AUTH::CONNECTED'

	// Notification
	public static readonly NOTIFICATION_CLEAR = 'NOTIFICATION::CLEAR'
	public static readonly NOTIFICATION_UPDATE = 'NOTIFICATION::UPDATE'

	// Page specific (reload)
	public static readonly TRAINING_REFRESH = 'TRAINING::REFRESH'
};